import React from 'react';
import styles from './Modal.module.scss'
import { Modal, Select } from '@mantine/core';
import { IconBoxAlignRight, IconDeviceMobile, IconRulerMeasure, IconZoomCancel } from '@tabler/icons-react';
import { TextArea } from 'components/Input/TextBox/TextBox';
import { UseFormReturnType, useForm } from '@mantine/form';
import { Dropdown } from 'components/Input/Dropdown/Dropdown';

interface BugReportModalProps {
    form: UseFormReturnType<any>;
    opened: boolean;
    close: () => void;
    onButtonClick: () => void;
    label?: string;
}

const BugReportModal = ({ form, opened, close, onButtonClick, ...rest }: BugReportModalProps) => {

    return (
        <Modal opened={opened} onClose={close} title="Report a Bug">
            <div className={styles.modal}>
                <Dropdown
                    label="Category"
                    placeholder="Select a category"
                    data={["BUG", "UI/UX", "FEATURE", "PERFORMANCE", "SECURITY", "OTHER"]}
                    formInstance={form}
                    name={'category'}
                    style={{ marginBottom: '16px' }}
                />
                <TextArea
                    label="What happened?"
                    placeholder="Please briefly describe what happened."
                    formInstance={form}
                    name="description"
                />
                <div className={styles.footerSection}>
                    <button onClick={onButtonClick} className={styles.modalSecondaryButton}>Cancel</button>
                    <button onClick={onButtonClick} className={styles.modalButton}>Send</button>

                </div>


            </div>
        </Modal>

    );
};

export default BugReportModal;
